import { Button, Modal, Table, TableActionBarRow } from "melco-ui";
import { useTranslation } from "react-i18next";

import { useState } from "react";
import { usePayments } from "../../../hooks/reports/usePayments";
//import { useRolesContext } from "../../../hooks/roles/useRolesContext";
import { ControlcenterMelcoModelsPaymentListItem, TableCellLink } from "melco-shared-logic";
import { PaymentsListFilter } from "./PaymentsListFilter";
import { ProcessPaymentDrawer } from "../drawer/ProcessPaymentDrawer";
import { ValueOrFallback } from "../../table/ValueOrFallback";

type PaymentsListPropTypes = {
  openProcessPaymentDrawer: boolean;
  setOpenProcessPaymentDrawerFunction: (v: boolean) => void;
};

export enum Status {
  Created = 1,
  Processed = 2,
  Archived = 3
}

export const PaymentsList: React.FC<PaymentsListPropTypes> = ({
  openProcessPaymentDrawer,
  setOpenProcessPaymentDrawerFunction,
}) => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    pagination,
    filtersChange,
    refetch,
  } = usePayments();
  console.log("data ", JSON.stringify(data))
  const { t } = useTranslation();
  // const { roles } = useRolesContext();
  const [isProcessPaymentDrawerOpen, setProcessPaymentDrawerOpen] = useState(false);
  const [processPaymentDetails, setProcessPaymentDetails] =
    useState<ControlcenterMelcoModelsPaymentListItem>();
  const [isAlreadyProcessed, setIsAlreadyProcessed] = useState<boolean>(false)
  const [processPaymentTransId, setProcessPaymentTransId] = useState<string>()
  const handleProcessPaymentClick = (item: ControlcenterMelcoModelsPaymentListItem) => {
    setProcessPaymentDetails(item);
    setProcessPaymentDrawerAction(true);
    setProcessPaymentTransId(item?.id ?? "")
  };

  const setProcessPaymentDrawerAction = (action: boolean) => {
    setProcessPaymentDrawerOpen(action);
    if (!action) refetch();
  };

  const columns = [
    {
      title: t('payments.table.column.melco_customer_id'),
      key: "melco_customer_id",
      //dataIndex: "melco_customer_id",
      sorter: true,
      //width: 70,

      render: (rowObj: ControlcenterMelcoModelsPaymentListItem) => (
        <TableCellLink
          onClick={() => {
            //  if (rowObj.payment_status == 2) { setIsAlreadyProcessed(true) }
            // else {
            handleProcessPaymentClick(rowObj)
            //  }
          }}
          to=""
        // style={
        //   !rowObj?.melco_customer_id
        //     ? { textDecoration: 'none', color: '#999' }
        //     : undefined
        // }
        >
          <ValueOrFallback
            value={rowObj?.melco_customer_id}
            fallback={t("payments.table.empty")}
          />
        </TableCellLink>
      ),
    },
    {
      title: t("payments.table.column.user_name"),
      key: "user_name",
      dataIndex: "user_name",
      sorter: true,
      width: 230,
    },

    {
      title: t("payments.table.column.country"),
      key: "country_code",
      dataIndex: "country_code",
      sorter: true,
      width: 110,
    },
    {
      title: t("payments.table.column.transaction_id"),
      key: "transaction_id",
      sorter: true,
      dataIndex: "transaction_id"
      ,
      width: 230
    },
    {
      title: t("payments.table.column.payment_amount"),
      key: "payment_amount",
      render: (rowObj: ControlcenterMelcoModelsPaymentListItem) => <>{rowObj?.payment_status === 1 ? "" : "$" + rowObj.payment_amount}</>,
      sorter: true,
      width: 190
    },
    {
      title: t("payments.table.column.price"),
      key: "price",
      //dataIndex: "price",
      sorter: true,
      width: 80,
      render: (rowObj: ControlcenterMelcoModelsPaymentListItem) => <>{"$" + rowObj.price}</>,
    },
    {
      title: t("payments.table.column.qty"),
      key: "qty",
      dataIndex: "qty",
      sorter: true,
      width: 80,
    },
    {
      title: t("payments.table.column.payment_entry_date"),
      key: "payment_entry_date",
      //dataIndex: "payment_entry_date",
      sorter: true,

      width: 230,
      //  width: "auto",
      render: (rowObj: ControlcenterMelcoModelsPaymentListItem) => (
        <>
          {rowObj.payment_entry_date
            ? new Date(rowObj.payment_entry_date).toLocaleString()
            : ""}
        </>
      ),
    },




    {
      title: t("payments.table.column.service_start_date"),
      key: "service_start_date",
      //   dataIndex: "service_start_date",
      sorter: true,
      width: 160,
      render: (rowObj: ControlcenterMelcoModelsPaymentListItem) => (
        <>
          {rowObj.service_start_date
            ? new Date(rowObj.service_start_date).toLocaleDateString()
            : ""}
        </>
      ),
    },
    {
      title: t("payments.table.column.service_end_date"),
      key: "service_end_date",
      //    dataIndex: "service_end_date",
      sorter: true,
      width: 160,
      render: (rowobj: ControlcenterMelcoModelsPaymentListItem) => (
        <>
          {rowobj.service_end_date
            ? new Date(rowobj.service_end_date).toLocaleDateString()
            : ""}
        </>
      ),
    },

    {
      title: t("payments.table.column.affiliate_name"),
      key: "affiliate_name",
      dataIndex: "affiliate_name",

      sorter: true,
      width: 230,
    },
    {
      title: t("payments.table.column.payment_status"),
      key: "payment_status",
      //dataIndex: "payment_status",
      render: (rowObj: ControlcenterMelcoModelsPaymentListItem) => (
        <> {Status[rowObj?.payment_status ?? -1] || t("payments.table.unknown")}</>
      ),
      sorter: true,
      width: 90,
    },
    {
      title: t("payments.table.column.product_level_code"),
      key: "product_level_code",
      dataIndex: "product_level_code",
      sorter: true,
      width: 90,
    },
    {
      title: t("payments.table.column.acc_resource_id"),
      key: "acc_resource_id",
      dataIndex: "acc_resource_id",
      sorter: true,
      width: 210,
      fixed: "right" as const
    },
    {
      title: t("payments.table.column.amount"),
      key: "amount",
      //dataIndex: "amount",
      render: (rowObj: ControlcenterMelcoModelsPaymentListItem) => <>{"$" + rowObj.amount}</>,
      sorter: true,
      width: 150,
      fixed: "right" as const
    },
    {
      title: t("payments.table.column.processing_date"),
      fixed: "right" as const,
      key: "processing_date",
      // dataIndex: "processing_date",
      sorter: true,
      width: 210,

      render: (rowObj: ControlcenterMelcoModelsPaymentListItem) => (
        <>
          {rowObj.processing_date
            ? new Date(rowObj.processing_date).toLocaleString()
            : ""}
        </>
      ),
    },];





  return (
    <>
      <TableActionBarRow>
        <PaymentsListFilter
          onFiltersChange={filtersChange}
        />
      </TableActionBarRow>
      <Table
        showSorterTooltip={false}
        sticky
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={pagination}
        rowKey="id"
        // rowSelection={rowSelection}
        // onRow={onRow}
        noDataMessage={t("payments.table.no_data_message")}
        errorComponent={errorComponent}
        scroll={{ x: 'max-content' }}
      />

      {
        <ProcessPaymentDrawer
          isDrawerOpen={isProcessPaymentDrawerOpen}
          setDrawerOpen={setProcessPaymentDrawerAction}
          //processPaymentDetails={processPaymentDetails}
          id={processPaymentTransId}
        />
      }
      {isAlreadyProcessed &&
        <Modal
          open={isAlreadyProcessed}
          onCancel={() => { setIsAlreadyProcessed(false) }}
          //  footer={null}       // hides default OK/Cancel buttons
          closable={false}     // shows the top-right "X"
          width={300}
          footer={[
            <Button key="ok" type="primary" onClick={() => setIsAlreadyProcessed(false)}>
              {t("payments.table.modal.footer.button")}
            </Button>,
          ]}
        >

          {t("payments.table.modal.message")}
        </Modal>
      }
    </>
  );
};